import { render } from "./DgWohnungStep11b.vue?vue&type=template&id=d7903860"
import script from "./DgWohnungStep11b.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep11b.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__